import request from '@/utils/request'

export function getWechatJsSdkConfig(url) {
  return request.get('/wechat/js-sdk-config', {
    params: { url },
    skipErrorToast: true
  })
}
